import { advanceMethodOptions, stateWeightingCriteriaOptions } from '../data/select.options.js'

const getConfigStatusesLayerFromMetadata = function (metadata) {
  const cfg = metadata && metadata.config && metadata.config.statuses ? metadata.config.statuses : null;
  return cfg
}

const getMethodRegisterAdvanceSelected = function (metadata) {
  const config = getConfigStatusesLayerFromMetadata(metadata);

  if (!config) return null;

  let cfg = {
    advance_method: null,
    weighting_criteria: null
  }
  if (config.avance_method) {
    cfg.advance_method = advanceMethodOptions.find(option => option.value === config.avance_method) || null;
  }

  if (config.weighting_criteria) {
    cfg.weighting_criteria = stateWeightingCriteriaOptions.find(option => option.value === config.weighting_criteria) || null;
  }

  return cfg;
}

const isMethodAndAdvanceDefault = function (metadata) {
  const config = getConfigStatusesLayerFromMetadata(metadata);

  if (!config) return true;

  // Un flag ausente (null/undefined) cuenta como 'default': una config parcial
  // (p.ej. avance_method='default' sin weighting_criteria) sigue siendo default y
  // debe mostrar total/pendiente/ejecutado, no la barra de progreso.
  const isDefault = value => value == null || value === 'default';

  return isDefault(config.avance_method) && isDefault(config.weighting_criteria);
}

export function getProgressLayerFromMetadata (metadata, type=null) {
  let key = 'advance';
  if (type)
    key += '_' + type.toLowerCase();

  if (metadata && metadata['progress_layer'] !== undefined && metadata['progress_layer'][key] !== undefined) {
    return metadata['progress_layer'][key];
  }
  return 0; // Default value if not found
}

export function getStatusesLayerFromMetadata(metadata, typeStatus) {
  const keyMap = {
    progress: 'progress_statuses',
    incident: 'incident_statuses',
  };

  const key = keyMap[typeStatus];
  return key ? (metadata?.[key] ?? []) : [];
}

export {
  getConfigStatusesLayerFromMetadata,
  getMethodRegisterAdvanceSelected,
  isMethodAndAdvanceDefault
};
